function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import React, { useContext } from "react";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
import { BreakpointsContext } from "../Breakpoints/BreakpointsProvider";
var S_WIDTH = 420;
var M_WIDTH = 560;
var L_WIDTH = 800;
var SIDE_WIDTH = 480;
var S_MARGIN = 16;
var buildStyle = function(param, param1) {
    var backgroundColor = param.backgroundColor, size = param.size, boxShadow = param.depth.boxShadow, readingDirection = param1.readingDirection;
    return {
        wrapper: {
            base: {
                position: 'fixed',
                height: '100%',
                width: '100vw',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                top: 0,
                left: 0
            }
        },
        outerContainer: {
            base: {
                border: 'none',
                outline: 'none',
                boxSizing: 'border-box',
                maxHeight: '100vh',
                maxWidth: '100vw',
                backgroundColor: backgroundColor.base,
                overflow: 'hidden',
                boxShadow: "".concat(boxShadow['4'].xOffset, " ").concat(boxShadow['4'].yOffset, " ").concat(boxShadow['4'].blurRadius, " ").concat(boxShadow['4'].spreadRadius, " ").concat(boxShadow['4'].color)
            },
            center: {
                base: {
                    borderRadius: size.border.radius.fiveX,
                    maxHeight: '100vh',
                    maxWidth: '100vw'
                },
                size: {
                    s: function(windowWidth) {
                        return {
                            width: S_WIDTH,
                            maxWidth: "calc(".concat(windowWidth ? "".concat(windowWidth, "px") : '100vw', " - ").concat(S_MARGIN * 2, "px)")
                        };
                    },
                    m: function(windowWidth, windowHeight) {
                        return _defineProperty({
                            width: M_WIDTH
                        }, "@media (max-width: ".concat(M_WIDTH, "px)"), {
                            borderRadius: 0,
                            maxWidth: windowWidth || '100vw',
                            height: windowHeight || '100%',
                            maxHeight: windowHeight || '100vh'
                        });
                    },
                    l: function(windowWidth, windowHeight) {
                        return _defineProperty({
                            width: L_WIDTH
                        }, "@media (max-width: ".concat(L_WIDTH, "px)"), {
                            borderRadius: 0,
                            maxWidth: windowWidth || '100vw',
                            height: windowHeight || '100%',
                            maxHeight: windowHeight || '100vh'
                        });
                    }
                },
                fullscreen: {
                    borderRadius: 0,
                    width: '100vw',
                    height: '100%'
                }
            },
            side: {
                horizontalBase: {
                    position: 'fixed',
                    top: 0,
                    bottom: 0,
                    maxWidth: '100vw',
                    width: SIDE_WIDTH
                },
                right: {
                    base: {
                        right: 0
                    }
                },
                left: {
                    base: {
                        left: 0
                    }
                },
                verticalBase: {
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    width: '100vw',
                    maxHeight: '100vh'
                },
                bottom: {
                    base: {
                        bottom: 0,
                        borderTopLeftRadius: size.border.radius.fiveX,
                        borderTopRightRadius: size.border.radius.fiveX
                    }
                }
            }
        },
        contentContainer: {
            base: _objectSpread({}, readingDirection, {
                boxSizing: 'border-box',
                height: '100%',
                width: '100%',
                overflow: 'hidden'
            })
        }
    };
};
export function useStyle(param) {
    var format = param.format, height = param.height, isRtl = param.isRtl, zIndex = param.zIndex;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var breakpointsObject = useContext(BreakpointsContext);
    var ref11;
    var ref12 = (ref11 = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref11 !== void 0 ? ref11 : {}, outerContainer = ref12.outerContainer, contentContainer = ref12.contentContainer, wrapper = ref12.wrapper;
    var correctedZIndex = typeof zIndex === 'undefined' ? 1 : zIndex;
    return {
        outerContainerStyle: _objectSpread({}, outerContainer === null || outerContainer === void 0 ? void 0 : outerContainer.base, {
            zIndex: correctedZIndex
        }, breakpointsObject.widthWindow ? {
            maxWidth: breakpointsObject.widthWindow
        } : {}, breakpointsObject.heightWindow ? {
            maxHeight: breakpointsObject.heightWindow
        } : {}, format === 's' || format === 'm' || format === 'l' ? _objectSpread({}, height ? {
            height: height
        } : {}, outerContainer === null || outerContainer === void 0 ? void 0 : (ref = outerContainer.center) === null || ref === void 0 ? void 0 : ref.base, format === 'm' ? outerContainer === null || outerContainer === void 0 ? void 0 : (ref1 = outerContainer.center) === null || ref1 === void 0 ? void 0 : ref1.size.m(breakpointsObject.widthWindow, breakpointsObject.heightWindow) : {}, format === 's' ? outerContainer === null || outerContainer === void 0 ? void 0 : (ref2 = outerContainer.center) === null || ref2 === void 0 ? void 0 : ref2.size.s(breakpointsObject.widthWindow) : {}, format === 'l' ? outerContainer === null || outerContainer === void 0 ? void 0 : (ref3 = outerContainer.center) === null || ref3 === void 0 ? void 0 : ref3.size.l(breakpointsObject.widthWindow, breakpointsObject.heightWindow) : {}) : {}, format === 'fullscreen' ? _objectSpread({}, outerContainer === null || outerContainer === void 0 ? void 0 : (ref4 = outerContainer.center) === null || ref4 === void 0 ? void 0 : ref4.base, outerContainer === null || outerContainer === void 0 ? void 0 : (ref5 = outerContainer.center) === null || ref5 === void 0 ? void 0 : ref5.fullscreen, breakpointsObject.heightWindow ? {
            height: breakpointsObject.heightWindow,
            maxHeight: breakpointsObject.heightWindow
        } : {}) : {}, format === 'start' || format === 'end' ? _objectSpread({}, outerContainer === null || outerContainer === void 0 ? void 0 : (ref6 = outerContainer.side) === null || ref6 === void 0 ? void 0 : ref6.horizontalBase, format === 'end' && !isRtl || format === 'start' && isRtl ? outerContainer === null || outerContainer === void 0 ? void 0 : (ref7 = outerContainer.side) === null || ref7 === void 0 ? void 0 : ref7.right.base : outerContainer === null || outerContainer === void 0 ? void 0 : (ref8 = outerContainer.side) === null || ref8 === void 0 ? void 0 : ref8.left.base, breakpointsObject.heightWindow ? {
            height: breakpointsObject.heightWindow
        } : {}) : {}, format === 'bottom' ? _objectSpread({}, outerContainer === null || outerContainer === void 0 ? void 0 : (ref9 = outerContainer.side) === null || ref9 === void 0 ? void 0 : ref9.verticalBase, outerContainer === null || outerContainer === void 0 ? void 0 : (ref10 = outerContainer.side) === null || ref10 === void 0 ? void 0 : ref10.bottom.base) : {}),
        contentContainerStyle: _objectSpread({}, contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.base),
        scrimStyle: _objectSpread({}, breakpointsObject.widthWindow ? {
            width: breakpointsObject.widthWindow
        } : {}, breakpointsObject.heightWindow ? {
            height: breakpointsObject.heightWindow
        } : {}),
        wrapperStyle: _objectSpread({}, wrapper === null || wrapper === void 0 ? void 0 : wrapper.base, {
            zIndex: correctedZIndex
        })
    };
}
export default useStyle;
